<template>
    <external-list
            endpoint="/api/v2/portals"
            @show="show"
    >
        <template v-slot:default="{ row: portal }">
            <td>
                <router-link :to="getUrl(portal)">
                    {{ portal.attributes.name }}
                </router-link>
            </td>
        </template>
    </external-list>
</template>

<script>
    import ExternalList from '@/components/Panels/Lists/External'

    export default {
        components: {ExternalList},

        methods: {
            show(portal) {
                this.$router.push(this.getUrl(portal))
            },

            getUrl(portal) {
                return '/marketing-sites/' + portal.id
            }
        }
    }
</script>
